import React, { useEffect, useCallback, useState } from 'react';

import PageContentWrapper from '../../../pages/components/pageContentWrapper';
import { type RowData } from '../../../components/table/Table';

import { getTravelerProfiles } from '../../../service/travelerProfileService';
import { filterAndtransformToTravelerProfileTableRows } from '../../../transformer/travelerProfileTransformer';

import { TravelerProfileSearchCriteriaForm } from './TravelerProfileSearchCriteriaForm';
import { TravelerProfileList } from './TravelerProfileList';

import type { TravelerProfileSearchCriteria } from '../../../types/travelerProfile';
import { goTo, hasWorldAware, setHelpPage} from '../../../configTdm';

import type { User } from '../../../types/user';
import { getProperty } from '../../../fsConfig';
import FullPageLoadingSpinner from '../../../pages/components/fullPageLoadingSpinner';

type Props = {
  user: any;
};

const searchErrors = {
  backendFailure: 'Failed to search traveler profiles. Please try again.',
};

const TravelerProfileSearchContainer: React.FC = () => {
  const user = getProperty('session', {});
  const [loading, setLoading] = useState<boolean>(true);
  const [searchError, setSearchError] = useState<string | null>(null);
  const [travelerProfileSearchRows, setTravelerProfileSearchRows] = useState<RowData[]>([]);

   useEffect(() => {
    setHelpPage('helpTravelerSearch');
      const initialLoadTimer = setTimeout(() => {
        setLoading(false);
      }, 1000);
      return () => clearTimeout(initialLoadTimer);
    }, []);

  const handleOnClear = useCallback((): void => {
    setSearchError(null);
    setTravelerProfileSearchRows([]);
  }, []);

  const handleSearch = useCallback((searchCriteria: TravelerProfileSearchCriteria): void => {
    setSearchError(null);
    setLoading(true);
    getTravelerProfiles(searchCriteria, hasWorldAware())
      .then(result => {
        const profileRows = filterAndtransformToTravelerProfileTableRows(
          result,
          [searchCriteria.email, searchCriteria.phoneNumberE164],
        ).map(profileRow => {
          const travelerKey = profileRow.values[0];
          const detailProfileRoute = `/agent/traveler/profile/searchresult/${travelerKey}`;
          profileRow.onClick = () => goTo(detailProfileRoute);
          return profileRow;
        });
        setTravelerProfileSearchRows(profileRows);
      })
      .catch(() => setSearchError(searchErrors.backendFailure))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PageContentWrapper loading={loading} title="TRAVELER PROFILE SEARCH">
         {loading && <FullPageLoadingSpinner />} {/* Conditionally render the spinner */}
      <TravelerProfileSearchCriteriaForm
        supportedSMSCountryCodes={user.supportedSMSCountryCodes}
        onSearch={handleSearch}
        onClear={handleOnClear}
        searchError={searchError}
      />
      <TravelerProfileList
        searchFailed={!!searchError}
        loading={loading}
        tableData={travelerProfileSearchRows}
      />
    </PageContentWrapper>
  );
};

export default TravelerProfileSearchContainer;